import { useEffect, useRef } from "react";
// import { ImageOverlay } from "./ImageOverlay";
import "./imageOverlay.css";

export function useImageOverlay({
  mode,
  map,
  imageSrc,
  initialNW,
  initialSE,
  initialRotate,
  onBoundsChanged,
  onImageLoaded,
  // mapReady,
}) {
  const overlayRef = useRef(null);

  useEffect(() => {
    // console.log(
    //   "useImageOverlay effect %s,%s,%s",
    //   mode,
    //   map ? "map set" : "map not",
    //   // imageSrc,
    //   // initialNW,
    //   // initialSE,
    //   // initialRotate,
    //   overlayRef.current ? "overlay set" : "overlay not set"
    // );
    if (!mode) return;
    if (!map) return;
    if (!imageSrc) return;
    if (!initialNW || !initialSE) return;
    if (!Number.isInteger(initialRotate)) return; // ✅ allows 0
    // if (overlayRef.current === null) return;

    let cancelled = false;

    (async () => {
      if (!window.google || !window.google.maps) {
        throw new Error("Google Maps JavaScript API not loaded");
      }

      let { ImageOverlay } = await import("./ImageOverlay");
      if (cancelled) return;

      overlayRef.current = new ImageOverlay({
        mode,
        map,
        imageSrc,
        initialNW,
        initialSE,
        // initialRotate,
        onBoundsChanged,
        onImageLoaded,
      });

      // console.log("%cImageOverlay mounted", "background: #f8c0f3;");
    })();

    return () => {
      cancelled = true;
      // console.log(
      //   "%cImageOverlay unmounted",
      //   "background: #f8c0f3;",
      //   overlayRef.current
      // );
      overlayRef.current?.setMap(null);
      overlayRef.current = null;
    };
  }, [
    mode,
    map,
    imageSrc,
    initialNW,
    initialSE,
    initialRotate,
    onBoundsChanged,
  ]);

  return overlayRef;
}
